import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import styled from 'styled-components'
import {
  STIPOP_API_HOST,
  STIPOP_API_KEY,
} from '../../_Components/Common/common'
import PageTitle from '../../_Components/Common/PageTitle/PageTitle'
import Dropdown from '../../Components/NewApp/Dropdown'
import VersionBanner from '../../Components/NewApp/VersionBanner'
import NewApp from '../../Components/NewApp/NewApp'
import EditTable from '../../Components/NewApp/EditTable'
import LoadingSpinner from '../../Components/Common/Loading/LoadingSpinner'
import Loading from '../../Components/Common/Loading/Loading'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'

const index = () => {
  const [mount, setMount] = useState(false)
  // current langauge
  const [lang, setLang] = useState('en')
  // current page
  const [page, setPage] = useState('home')
  const [filter, setFilter] = useState('all')
  // banner 페이지의 collectionName 필터. companion(=ai) 과 nsfw 배너가 같은 page 에 섞여 있어 골라볼 수 있게 한다.
  const [bannerName, setBannerName] = useState('nsfw')
  const [free, setFree] = useState(false)
  // version
  const [allV, setAllV] = useState([])
  const [newV, setNewV] = useState([])
  const [liveV, setLiveV] = useState([])
  const [prevV, setPrevV] = useState([])
  // current selected version
  const [version, setVersion] = useState(null)
  // current lived version
  const [liveVersion, setLiveVersion] = useState(null)
  // stickers
  const [homeStickers, setHomeStickers] = useState([])
  const [newStickers, setNewStickers] = useState(null)
  const [searchStickers, setSearchStickers] = useState([])
  const [topStickers, setTopStickers] = useState([])
  const [assistants, setAssistants] = useState([])
  // collection data
  const [collection, setCollection] = useState([])
  // collection package edit
  const [edit, setEdit] = useState('')
  // 미리보기 목업 가로 폭(px). 사용자가 직접 조절하며 localStorage 에 저장한다.
  const [previewWidth, setPreviewWidth] = useState(() => {
    const saved = Number(
      typeof window !== 'undefined'
        ? window.localStorage.getItem('newAppPreviewWidth')
        : null
    )
    return saved >= 320 && saved <= 1200 ? saved : 600
  })
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('newAppPreviewWidth', String(previewWidth))
    }
  }, [previewWidth])
  // dropdown list
  const pageList = ['home', 'new', 'search', 'ai', 'nsfw', 'banner']
  const paidList = ['featured', 'free']
  const langList =
    page === 'nsfw' || page === 'ai' || page === 'banner'
      ? [
          { code: 'en', lang: 'English' },
          { code: 'ko', lang: 'Korean' },
          { code: 'es', lang: 'Spanish' },
          { code: 'pt', lang: 'Portuguese' },
          { code: 'ja', lang: 'Japaness' },
          { code: 'id', lang: 'Indonesian' },
          { code: 'vi', lang: 'Vietnamese' },
          { code: 'ms', lang: 'Malay' },
          { code: 'ar', lang: 'Arabic' },
          { code: 'hi', lang: 'Hindi' },
          { code: 'ru', lang: 'Russian' },
          { code: 'zh-TW', lang: 'Chinese' },
        ]
      : [
          { code: 'en', lang: 'English' },
          { code: 'ko', lang: 'Korean' },
          { code: 'es', lang: 'Spanish' },
          { code: 'pt', lang: 'Portuguese' },
          { code: 'ja', lang: 'Japaness' },
        ]
  const filterList = ['all', 'female', 'male']
  const bannerNameList = ['companion', 'nsfw']

  const [prevLoading, setPrevLoading] = useState(false)
  const [collectionLoading, setCollectionLoading] = useState(false)
  const [liveLoading, setLiveLoading] = useState(false)
  const [vLoading, setVLoading] = useState(false)
  const history = useHistory()

  // popup
  const [popup, setPopup] = useState(null)
  const popupRef = useRef()

  // selected copy language
  const [copyLang, setCopyLang] = useState([lang])

  // platform
  const [platform, setPlatform] = useState('stipopapp')

  // copy platform
  const [copyPlatform, setCopyPlatform] = useState('stipopapp')

  useEffect(() => {
    setMount(true)
  }, [])

  useEffect(() => {
    if (mount) {
      getVersion(lang)
    }
  }, [mount, page, lang, filter, bannerName, free])

  useEffect(() => {
    if (version) {
      getStickers(page, lang, version)
      getCollection(page, lang, version)
    }
  }, [version])

  useEffect(() => {
    console.log(homeStickers, newStickers, searchStickers, assistants)
  }, [homeStickers, newStickers, searchStickers, assistants])

  //change Page
  const changePage = async v => {
    if (page !== v) {
      await setPage(v)
    }
  }

  //change language
  const changeLang = async v => {
    if (lang !== v) {
      await setLang(v)
    }
  }

  const changeFilter = async v => {
    if (filter !== v) {
      await setFilter(v)
    }
  }

  const changeBannerName = async v => {
    if (bannerName !== v) {
      await setBannerName(v)
    }
  }

  // 어드민 조회 API 의 type 파라미터는 COLLECTION_NAME 을 비교한다. banner 페이지에서만 사용.
  const bannerType = () => (page === 'banner' ? bannerName : '')

  const filterByBannerName = list => {
    if (page !== 'banner' || !Array.isArray(list)) {
      return list
    }

    return list.filter(item => item.collectionName === bannerName)
  }

  const changeFree = async v => {
    if (free !== v) {
      await setFree(v)
    }
  }

  useEffect(() => {
    console.log(liveVersion)
  }, [liveVersion])

  // get version list
  const getVersion = async (lang, opt) => {
    await setVLoading(true)

    await axios
      .get(
        `/new/webAdmin/v2/collection/version?lang=${lang}&platform=${platform}`,
        {
          headers: {
            token: sessionStorage.getItem('token'),
          },
        }
      )
      .then(async ({ data }) => {
        if (data) {
          const result = data.result

          if (result && result.length > 0) {
            setAllV(result)
            setNewV(result.filter(item => item.STATUS === 'W'))
            setLiveV(result.filter(item => item.STATUS === 'Y'))
            setPrevV(result.filter(item => item.STATUS === 'N'))

            if (opt !== 'copy') {
              if (result.filter(item => item.STATUS === 'Y').length > 0) {
                await setVersion({
                  id: result.filter(item => item.STATUS === 'Y')[0].SEQ,
                  version: result.filter(item => item.STATUS === 'Y')[0]
                    .VERSION,
                  status: 'Y',
                })
                await setLiveVersion({
                  id: result.filter(item => item.STATUS === 'Y')[0].SEQ,
                  version: result.filter(item => item.STATUS === 'Y')[0]
                    .VERSION,
                  status: 'Y',
                })
              } else {
                await setVersion({
                  id: result[0].SEQ,
                  version: result[0].VERSION,
                  status: result[0].STATUS,
                })
                await setLiveVersion(null)
              }
            }

            await setVLoading(false)
          } else {
            setAllV([])
            setNewV([])
            setLiveV([])
            setPrevV([])
            setVersion(null)
            setLiveVersion(null)
            setCollection([])

            await setVLoading(false)
          }
        }
      })
  }

  // get selected version collection stickers
  const getStickers = async (page, lang, version) => {
    await setPrevLoading(true)
    if (version.status === 'Y') {
      if (page === 'home') {
        await axios
          .get(`${STIPOP_API_HOST}/v4/home?lang=${lang}&platform=${platform}`, {
            headers: {
              apikey: STIPOP_API_KEY,
            },
          })
          .then(({ data }) => {
            setHomeStickers(data.body.collectionList)
          })
      } else if (page === 'new') {
        await axios
          .get(`${STIPOP_API_HOST}/v4/new?lang=${lang}&platform=${platform}`, {
            headers: {
              apikey: STIPOP_API_KEY,
              token: '',
            },
          })
          .then(({ data }) => {
            setNewStickers({
              collectionList: data.body.collectionList.collectionList,
              newList: data.body.newList.newPackageList,
            })
          })
      } else if (page === 'search') {
        await axios
          .get(
            `${STIPOP_API_HOST}/v4/search/collection?lang=${lang}&platform=${platform}`,
            {
              headers: {
                apikey: STIPOP_API_KEY,
              },
            }
          )
          .then(({ data }) => {
            setSearchStickers(data.body.collectionList)
          })
      } else if (page === 'ai' || page === 'nsfw' || page === 'banner') {
        await axios
          .get(
            // version=v2 : 그룹채팅 큐레이션 섹션(groupList) 포함. 없으면 앱 구버전과 같이 1:1 섹션만 온다.
            `${STIPOP_API_HOST}/v4.0.1/assistant/collection?lang=${lang}&platform=${platform}&page=${page}&version=v2${
              filter === 'all' ? '' : `&filter=${filter}`
            }${free ? '&free=Y' : ''}`,
            {
              headers: {
                apikey: STIPOP_API_KEY,
              },
            }
          )
          .then(({ data }) => {
            // 라이브 버전 조회 API 는 collectionName 조건이 없어서 화면에서 걸러낸다.
            setAssistants(filterByBannerName(data.body.collectionList))
          })
      }
    } else {
      const params = `?page=${page}&type=${bannerType()}&status=${
        version.status
      }&version=${version.id}&lang=${lang}&platform=${platform}${
        filter === 'all' ? '' : `&filter=${filter}`
      }${free ? '&free=Y' : ''}`
      await axios
        .get(`/new/webAdmin/v2/collection` + params, {
          headers: {
            token: sessionStorage.getItem('token'),
          },
        })
        .then(({ data }) => {
          if (page === 'home') {
            setHomeStickers(data.result)
          } else if (page === 'new') {
            setNewStickers({
              collectionList: data.result.collectionList,
              newList: data.result.newList,
            })
          } else if (page === 'search') {
            setSearchStickers(data.result)
          } else if (page === 'ai' || page === 'nsfw' || page === 'banner') {
            setAssistants(data.result)
          }
        })
    }

    await axios
      .get(`${STIPOP_API_HOST}/v4/top/daily/${lang}`, {
        headers: {
          apikey: STIPOP_API_KEY,
          token: '',
        },
      })
      .then(({ data }) => {
        setTopStickers(data.body.topList)
      })
    await setPrevLoading(false)
  }

  const getCollection = async (page, lang, version) => {
    await setCollectionLoading(true)
    if (version) {
      const params = `?page=${page}&type=${bannerType()}&status=${
        version.status
      }&version=${version.id}&lang=${lang}${
        filter === 'all' ? '' : `&filter=${filter}`
      }${free ? '&free=Y' : ''}`
      await axios
        .get(`/new/webAdmin/v2/collection` + params, {
          headers: {
            token: sessionStorage.getItem('token'),
          },
        })
        .then(({ data }) => {
          if (page === 'new') {
            setCollection(data.result.collectionList)
          } else {
            setCollection(data.result)
          }
          setCollectionLoading(false)
        })
    }
  }

  const selectedCopyLang = lang => {
    if (copyLang.filter(l => l === lang).length > 0) {
      setCopyLang(copyLang.filter(l => l !== lang))
    } else {
      setCopyLang([...copyLang].concat(lang))
    }
  }

  const clickLive = async id => {
    await setLiveLoading(true)

    if (liveVersion) {
      await axios
        .put(
          `/new/webAdmin/v2/collection/status`,
          { status: 'N', version: liveVersion.id },
          {
            headers: {
              token: sessionStorage.getItem('token'),
            },
          }
        )
        .then(async () => {
          const params = {
            status: 'Y',
            version: id,
          }

          await axios
            .put(`/new/webAdmin/v2/collection/status`, params, {
              headers: {
                token: sessionStorage.getItem('token'),
              },
            })
            .then(() => {
              getVersion(lang)
              setLiveLoading(false)
              setPopup(null)
            })
        })
    } else {
      const params = {
        status: 'Y',
        version: id,
      }

      await axios
        .put(`/new/webAdmin/v2/collection/status`, params, {
          headers: {
            token: sessionStorage.getItem('token'),
          },
        })
        .then(() => {
          getVersion(lang)
          setLiveLoading(false)
          setPopup(null)
        })
    }
  }

  const clickDelete = id => {
    axios
      .delete(`/new/webAdmin/v2/collection/version/${id}`, {
        headers: {
          token: sessionStorage.getItem('token'),
        },
      })
      .then(() => {
        setEdit('')
        getVersion(lang)
        setPopup(null)
      })
  }

  const clickCopy = (id, version) => {
    const len = copyLang.length

    if (len === 1) {
      axios
        .post(
          `/new/webAdmin/v2/collection/version/${id}`,
          { lang: copyLang[0], platform: copyPlatform },
          {
            headers: {
              token: sessionStorage.getItem('token'),
            },
          }
        )
        .then(async ({ data }) => {
          if (copyPlatform === 'b2b') {
            await history.push(`/Banner/NewB2B`)
          }
          if (copyLang[0] === lang) {
            await getVersion(lang, 'copy')
            await setVersion({
              id: data.result,
              version: `${version.version} copy`,
              status: 'W',
            })
          } else {
            await setLang(copyLang[0])
          }
          await setPopup(null)
        })
    } else {
      copyLang.map((l, i) => {
        axios
          .post(
            `/new/webAdmin/v2/collection/version/${id}`,
            { lang: l, platform: copyPlatform },
            {
              headers: {
                token: sessionStorage.getItem('token'),
              },
            }
          )
          .then(async ({ data }) => {
            if (copyPlatform === 'b2b') {
              await history.push(`/Banner/NewB2B`)
            }
            if (l === lang) {
              await getVersion(lang, 'copy')
              await setVersion({
                id: data.result,
                version: `${version.version} copy`,
                status: 'W',
              })
            } else {
              if (i === len - 1) {
                await setLang(l)
              }
            }
            await setPopup(null)
          })
      })
    }
  }

  const renderPopup = (type, id) => {
    return (
      <PopupWrapper
        onClick={e => {
          if (popupRef.current && !popupRef.current.contains(e.target)) {
            setPopup(null)
            setCopyLang([lang])
          }
        }}
      >
        <PopupContent ref={popupRef}>
          {type === 'live' ? (
            <>
              <PopupHeader>라이브 출시</PopupHeader>
              <PopupBody>
                <div>라이브로 출시하시겠습니까?</div>
                <div>기존 라이브 버전은 이전 버전으로 이동됩니다.</div>
              </PopupBody>
              <PopupFooter>
                <button id="no" onClick={() => setPopup(null)}>
                  취소
                </button>
                <button
                  id="yes"
                  onClick={() => clickLive(id)}
                  disabled={liveLoading}
                >
                  라이브 출시
                </button>
              </PopupFooter>
            </>
          ) : type === 'delete' ? (
            <>
              <PopupHeader>버전 삭제</PopupHeader>
              <PopupBody>
                <div>{version.version} 버전을 정말 삭제하시겠습니까?</div>
              </PopupBody>
              <PopupFooter>
                <button id="no" onClick={() => setPopup(null)}>
                  취소
                </button>
                <button id="yes" onClick={() => clickDelete(id)}>
                  삭제
                </button>
              </PopupFooter>
            </>
          ) : (
            type === 'copy' && (
              <>
                <PopupHeader>버전 복제</PopupHeader>
                <PopupBody>
                  <div>복제할 언어를 선택해 주세요.</div>
                  <div style={{ display: 'flex' }}>
                    {langList.map((item, i) => (
                      <LangBtn
                        key={i}
                        onClick={() => selectedCopyLang(item.code)}
                        selected={copyLang.indexOf(item.code) > -1}
                      >
                        {item.lang}
                      </LangBtn>
                    ))}
                  </div>
                  <div>복제할 플랫폼을 선택해 주세요.</div>
                  <div style={{ display: 'flex' }}>
                    <LangBtn
                      onClick={() => setCopyPlatform('stipopapp')}
                      selected={copyPlatform === 'stipopapp'}
                    >
                      App
                    </LangBtn>
                    <LangBtn
                      onClick={() => setCopyPlatform('b2b')}
                      selected={copyPlatform === 'b2b'}
                    >
                      B2B
                    </LangBtn>
                  </div>
                  {copyLang.length > 0 && (
                    <>
                      <SpaceResponsive height={20} />
                      <div>{version.version} 버전을 복제하시겠습니까?</div>
                      <div>복제한 버전은 새로운 큐레이션에 등록됩니다.</div>
                    </>
                  )}
                </PopupBody>
                <PopupFooter deactive={copyLang.length === 0}>
                  <button
                    id="no"
                    onClick={() => {
                      setPopup(null)
                      setCopyLang([lang])
                    }}
                  >
                    취소
                  </button>
                  <button
                    id="yes"
                    onClick={() => {
                      if (copyLang.length > 0) {
                        clickCopy(id, version)
                      }
                    }}
                  >
                    복제
                  </button>
                </PopupFooter>
              </>
            )
          )}
        </PopupContent>
      </PopupWrapper>
    )
  }

  return (
    <>
      <PageTitle
        mainTitle={'New App'}
        v1Link={''}
        navNames={['Banners', 'New App']}
      />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '0 10px 8px',
        }}
      >
        <span style={{ fontSize: '13px', color: '#666' }}>미리보기 폭</span>
        <input
          type="range"
          min={320}
          max={1000}
          step={10}
          value={previewWidth}
          onChange={e => setPreviewWidth(Number(e.target.value))}
          style={{ width: '160px' }}
        />
        <input
          type="number"
          min={320}
          max={1200}
          step={10}
          value={previewWidth}
          onChange={e => {
            const v = Number(e.target.value)
            if (!Number.isNaN(v)) {
              setPreviewWidth(Math.min(1200, Math.max(320, v)))
            }
          }}
          style={{ width: '64px' }}
        />
        <span style={{ fontSize: '13px', color: '#666' }}>px</span>
      </div>
      <Wrapper>
        {popup && renderPopup(popup.type, popup.id)}
        <BannerWrapper>
          <VersionBanner
            version={version}
            setVersion={setVersion}
            getVersion={getVersion}
            allV={allV}
            newV={newV}
            liveV={liveV}
            prevV={prevV}
            lang={lang}
            setPopup={setPopup}
            platform={platform}
            isLoading={vLoading}
          />
        </BannerWrapper>
        <EditWrapper>
          {version && (
            <Version>
              <div>
                버전 {version.version} ({version.id})
              </div>
              {!edit
                ? version.status !== 'Y' && (
                    <button
                      onClick={() => {
                        setPopup({ id: version.id, type: 'live' })
                      }}
                    >
                      라이브 출시
                    </button>
                  )
                : edit === 'new'
                ? `New Banner`
                : `Editing [${
                    collection
                      ? collection.filter(item => item.collectionId === edit)[0]
                          .collectionName
                      : ''
                  }] [Banner #${
                    Number(
                      collection.findIndex(item => item.collectionId === edit)
                    ) + 1
                  }]`}
            </Version>
          )}
          <div style={{ display: 'flex', height: 'calc(100% - 30px)' }}>
            <PreviewWrapper width={previewWidth}>
              <div
                style={{
                  height: '30px',
                  margin: '15px 0',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Dropdown
                  list={pageList}
                  onChange={e => changePage(e.target.value)}
                  value={page}
                  type={'page'}
                />
                <div style={{ width: '10px' }} />
                <Dropdown
                  list={langList}
                  onChange={e => changeLang(e.target.value)}
                  value={lang}
                  type={'lang'}
                />
                <div style={{ width: '10px' }} />
                {(page === 'nsfw' || page === 'ai' || page === 'banner') && (
                  <>
                    {page === 'banner' && (
                      <>
                        <Dropdown
                          list={bannerNameList}
                          onChange={e => changeBannerName(e.target.value)}
                          value={bannerName}
                          type={'page'}
                        />
                        <div style={{ width: '10px' }} />
                      </>
                    )}
                    <Dropdown
                      list={filterList}
                      onChange={e => changeFilter(e.target.value)}
                      value={filter}
                      type={'page'}
                    />
                    <div style={{ width: '10px' }} />
                    {page !== 'banner' && (
                      <Dropdown
                        list={paidList}
                        onChange={e =>
                          changeFree(e.target.value === 'free' ? true : false)
                        }
                        value={free ? 'free' : 'featured'}
                        type={'page'}
                      />
                    )}
                  </>
                )}
              </div>
              {version && (
                <NewApp
                  homeStickers={homeStickers}
                  newStickers={newStickers}
                  searchStickers={searchStickers}
                  topStickers={topStickers}
                  assistants={assistants}
                  page={page}
                  isLoading={prevLoading}
                  lang={lang}
                  width={previewWidth}
                />
              )}
            </PreviewWrapper>
            {version && (
              <CurationWrapper>
                {collectionLoading ? (
                  <LoadingSpinner />
                ) : (
                  <EditTable
                    tableData={collection}
                    getCollection={getCollection}
                    getStickers={getStickers}
                    page={page}
                    version={version}
                    lang={lang}
                    edit={edit}
                    setEdit={setEdit}
                    platform={platform}
                    filter={filter}
                    free={free}
                  />
                )}
              </CurationWrapper>
            )}
          </div>
        </EditWrapper>
      </Wrapper>
    </>
  )
}

export default index

export const SpaceResponsive = styled.div`
  height: ${props => `${props.height}px`};
`

export const Title = styled.div`
  height: 22px;
  font-size: 18px;
  font-family: Roboto, sans-serif;
  font-weight: bold;
  letter-spacing: 0.21px;
`

const Wrapper = styled.div`
  display: flex;
  padding: 0 10px;
  overflow-y: hidden;
  width: 100%;
  height: calc(100vh - 140px);
  overflow-x: auto;
  position: relative;
`

const BannerWrapper = styled.div`
  width: 240px;
  min-width: 240px;
  height: calc(100% - 25px);
  border: 1px solid #dbdbdb;
  margin-right: 10px;
  margin-top: 15px;
  box-sizing: border-box;
`

const Version = styled.div`
  width: 100%;
  height: 30px;
  font-size: 20px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    height: 40px;
    padding: 0 15px;
    box-sizing: border-box;
    font-weight: bold;
    background-color: #ff4500;
    color: #fff;
    border-radius: 5px;
    border: none;
  }
`

const PreviewWrapper = styled.div`
  width: ${props => props.width || 600}px;
  min-width: ${props => props.width || 600}px;
`

const EditWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  width: calc(100% - 255px);
  height: calc(100% - 25px);
`

const CurationWrapper = styled.div`
  width: 100%;
  min-width: 400px;
`

const PopupWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
`

const PopupContent = styled.div`
  min-width: 400px;
  min-height: 250px;
  background-color: #fff;
`

const PopupHeader = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ecf0f5;
  font-size: 20px;
  font-weight: bold;
  padding: 15px;
  box-sizing: border-box;
`

const PopupBody = styled.div`
  width: 100%;
  min-height: 130px;
  padding: 15px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const LangBtn = styled.button`
  height: 30px;
  border-radius: 5px;
  border: 1px solid ${props => (props.selected ? '#007ffb' : '#000')};
  background-color: ${props => (props.selected ? '#007ffb' : '#fff')};
  color: ${props => (props.selected ? '#fff' : '#000')};
  margin-right: 5px;
`

const PopupFooter = styled.div`
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: end;
  height: 60px;
  border-top: 1px solid #ecf0f5;

  #yes {
    background-color: #007ffb;
    color: #fff;
    height: 35px;
    padding: 0 10px;
    box-sizing: border-box;
    border-radius: 5px;
    border: none;
    cursor: ${props => props.deactive && 'not-allowed'};
    opacity: ${props => props.deactive && 0.4};

    &:hover {
      opacity: 0.8;
      font-weight: bold;
    }
  }

  #no {
    background-color: #dc143c;
    color: #fff;
    margin-right: 10px;
    height: 35px;
    padding: 0 10px;
    box-sizing: border-box;
    border-radius: 5px;
    border: none;

    &:hover {
      opacity: 0.8;
      font-weight: bold;
    }
  }
`
